// Code generated by gen-relref. DO NOT EDIT.

export type File =
    '/' |
    '/_index' |
    '/_index.html' |
    '/about-signature' |
    '/about-signature.html' |
    '/account-settings' |
    '/account-settings.html' |
    '/air-force-coins' |
    '/air-force-coins.html' |
    '/all-pricing' |
    '/all-pricing.html' |
    '/all-products' |
    '/all-products.html' |
    '/army-coins' |
    '/army-coins.html' |
    '/autism-awareness-month' |
    '/autism-awareness-month.html' |
    '/baseball-trading-pins' |
    '/baseball-trading-pins/index' |
    '/baseball-trading-pins/index.html' |
    '/blog' |
    '/blog.html' |
    '/blog/nad87zzpgkst' |
    '/blog/nad87zzpgkst.html' |
    '/cart' |
    '/cart.html' |
    '/challenge-coin-design' |
    '/challenge-coin-design/index' |
    '/challenge-coin-design/index.html' |
    '/challenge-coin-history' |
    '/challenge-coin-history.html' |
    '/change-password' |
    '/change-password.html' |
    '/checkout' |
    '/checkout.html' |
    '/coast-guard-coins' |
    '/coast-guard-coins.html' |
    '/coin-stand' |
    '/coin-stand.md' |
    '/commemorative-coin' |
    '/commemorative-coin.html' |
    '/components/img-partial' |
    '/components/img-partial/index' |
    '/components/img-partial/index.md' |
    '/contact' |
    '/contact.html' |
    '/contact/success' |
    '/contact/success.html' |
    '/corporate-coins' |
    '/corporate-coins.html' |
    '/create-a-custom-challenge-coin' |
    '/create-a-custom-challenge-coin.html' |
    '/custom-3D-challenge-coin' |
    '/custom-3D-challenge-coin.html' |
    '/custom-bottle-opener' |
    '/custom-bottle-opener.html' |
    '/custom-bottle-openers' |
    '/custom-bottle-openers/index' |
    '/custom-bottle-openers/index.md' |
    '/custom-club-hobby-challenge-coins' |
    '/custom-club-hobby-challenge-coins.html' |
    '/custom-company-coin' |
    '/custom-company-coin.html' |
    '/custom-dog-tag' |
    '/custom-dog-tag.html' |
    '/custom-ems-challenge-coins' |
    '/custom-ems-challenge-coins.html' |
    '/custom-golf-ball-marker' |
    '/custom-golf-ball-marker.html' |
    '/custom-handcuff-bottle-openers' |
    '/custom-handcuff-bottle-openers/index' |
    '/custom-handcuff-bottle-openers/index.md' |
    '/custom-k9-police-coins' |
    '/custom-k9-police-coins.html' |
    '/custom-law-enforcement-challenge-coins' |
    '/custom-law-enforcement-challenge-coins.html' |
    '/custom-nypd-challenge-coins' |
    '/custom-nypd-challenge-coins.html' |
    '/custom-photo-ornaments' |
    '/custom-photo-ornaments/index' |
    '/custom-photo-ornaments/index.md' |
    '/custom-school-coins' |
    '/custom-school-coins/index' |
    '/custom-school-coins/index.html' |
    '/custom-shape-coin' |
    '/custom-shape-coin.html' |
    '/custom-spinner-coin' |
    '/custom-spinner-coin.html' |
    '/custom-state-police-challenge-coins' |
    '/custom-state-police-challenge-coins.html' |
    '/custom-trophies' |
    '/custom-trophies/index' |
    '/custom-trophies/index.md' |
    '/custom-us-navy-challenge-coins' |
    '/custom-us-navy-challenge-coins.html' |
    '/dashboard' |
    '/dashboard.html' |
    '/display-coin' |
    '/display-coin/index' |
    '/display-coin/index.md' |
    '/dod-coins' |
    '/dod-coins.html' |
    '/entertainment-challenge-coin' |
    '/entertainment-challenge-coin.html' |
    '/error' |
    '/error.html' |
    '/faq' |
    '/faq.html' |
    '/firefighter-coin' |
    '/firefighter-coin.html' |
    '/forgot' |
    '/forgot.html' |
    '/free-quote' |
    '/free-quote.html' |
    '/gallery' |
    '/gallery.html' |
    '/government-coin' |
    '/government-coin.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index.md' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/_index' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/_index.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/about-signature' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/about-signature.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/account-settings' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/account-settings.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/all-pricing' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/all-pricing.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/all-products' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/all-products.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/blog' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/blog.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/blog/nad87zzpgkst' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/blog/nad87zzpgkst.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/cart' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/cart.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/challenge-coin-history' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/challenge-coin-history.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/change-password' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/change-password.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/checkout' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/checkout.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/coin-stand' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/coin-stand.md' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/components/img-partial' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/components/img-partial/index' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/components/img-partial/index.md' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/contact' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/contact.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/contact/success' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/contact/success.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/create-a-custom-challenge-coin' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/create-a-custom-challenge-coin.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-bottle-openers' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-bottle-openers/index' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-bottle-openers/index.md' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-handcuff-bottle-openers' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-handcuff-bottle-openers/index' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-handcuff-bottle-openers/index.md' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-trophies' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-trophies/index' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-trophies/index.md' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/dashboard' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/dashboard.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/display-coin' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/display-coin/index' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/display-coin/index.md' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/error' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/error.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/faq' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/faq.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/forgot' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/forgot.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/free-quote' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/free-quote.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/gallery' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/gallery.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/iframe-quote-form' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/iframe-quote-form.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/join' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/join.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/login' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/login-email' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/login-email.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/login.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/no-minimum-custom-coins' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/no-minimum-custom-coins/index' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/no-minimum-custom-coins/index.md' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/notification-settings' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/notification-settings.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/order' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/order-submitted' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/order-submitted.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/order.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders/make-order-payment' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders/make-order-payment.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders/track' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders/track.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/password-reset' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/password-reset.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/payment-history' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/payment-history.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/payment-methods' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/payment-methods.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/personalized-police-coin' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/personalized-police-coin.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/pricing' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/pricing.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/privacy' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/privacy.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/products' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/products.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quote' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quote.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quote/received' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quote/received.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quotes' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quotes.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/rally-towels' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/rally-towels.md' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/revision-requests' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/revision-requests.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/revisions' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/revisions.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/september-coin' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/september-coin.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/shipping-options' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/shipping-options.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/staging' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/staging.md' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/stock-products' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/stock-products.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/ordering/once-I-approve-the-proof-how-do-I-place-my-pin-order-into-production' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/ordering/once-I-approve-the-proof-how-do-I-place-my-pin-order-into-production.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/ordering/what-is-your-refund-policy' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/ordering/what-is-your-refund-policy.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/do-my-referral-rewards-expire' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/do-my-referral-rewards-expire.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/do-referral-codes-work-on-any-kind-of-order' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/do-referral-codes-work-on-any-kind-of-order.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/how-do-I-know-when-my-referral-code-is-used' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/how-do-I-know-when-my-referral-code-is-used.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/how-to-check-rewards-balance' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/how-to-check-rewards-balance.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/non-transferable-rewards' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/non-transferable-rewards.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/tax-exemptions' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/tax-exemptions.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/terms' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/terms.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/ticket' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/ticket.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/tracking' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/tracking.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/uploads' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/uploads.html' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/why-stop-at-just-coins' |
    '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/why-stop-at-just-coins.html' |
    '/iframe-quote-form' |
    '/iframe-quote-form.html' |
    '/international-coins' |
    '/international-coins.html' |
    '/join' |
    '/join.html' |
    '/large-coins' |
    '/large-coins.html' |
    '/login' |
    '/login-email' |
    '/login-email.html' |
    '/login.html' |
    '/made-in-usa-challenge-coins' |
    '/made-in-usa-challenge-coins/index' |
    '/made-in-usa-challenge-coins/index.html' |
    '/marine-corps-coins' |
    '/marine-corps-coins.html' |
    '/military-challenge-coin' |
    '/military-challenge-coin/index' |
    '/military-challenge-coin/index.html' |
    '/multi-tool' |
    '/multi-tool.html' |
    '/new-trading-pin' |
    '/new-trading-pin.html' |
    '/no-minimum-custom-coins' |
    '/no-minimum-custom-coins/index' |
    '/no-minimum-custom-coins/index.md' |
    '/nonprofit-challenge-coins' |
    '/nonprofit-challenge-coins.html' |
    '/notification-settings' |
    '/notification-settings.html' |
    '/order' |
    '/order-submitted' |
    '/order-submitted.html' |
    '/order.html' |
    '/orders' |
    '/orders.html' |
    '/orders/make-order-payment' |
    '/orders/make-order-payment.html' |
    '/orders/track' |
    '/orders/track.html' |
    '/password-reset' |
    '/password-reset.html' |
    '/payment-history' |
    '/payment-history.html' |
    '/payment-methods' |
    '/payment-methods.html' |
    '/personalized-police-coin' |
    '/personalized-police-coin.html' |
    '/plating-options' |
    '/plating-options.html' |
    '/police-coin' |
    '/police-coin/index' |
    '/police-coin/index.html' |
    '/pricing' |
    '/pricing.html' |
    '/privacy' |
    '/privacy.html' |
    '/products' |
    '/products.html' |
    '/quote' |
    '/quote.html' |
    '/quote/received' |
    '/quote/received.html' |
    '/quotes' |
    '/quotes.html' |
    '/rally-towels' |
    '/rally-towels.md' |
    '/revision-requests' |
    '/revision-requests.html' |
    '/revisions' |
    '/revisions.html' |
    '/round-challenge-coin' |
    '/round-challenge-coin.html' |
    '/safety-coins' |
    '/safety-coins.html' |
    '/september-coin' |
    '/september-coin.html' |
    '/shedding-some-light-on-glow-in-the-dark-challenge-coins' |
    '/shedding-some-light-on-glow-in-the-dark-challenge-coins.html' |
    '/shipping-options' |
    '/shipping-options.html' |
    '/sports-coin' |
    '/sports-coin.html' |
    '/staging' |
    '/staging.md' |
    '/start-a-rush-trading-pin-design' |
    '/start-a-rush-trading-pin-design.html' |
    '/stock-products' |
    '/stock-products.html' |
    '/support' |
    '/support.html' |
    '/support/ordering/once-I-approve-the-proof-how-do-I-place-my-pin-order-into-production' |
    '/support/ordering/once-I-approve-the-proof-how-do-I-place-my-pin-order-into-production.html' |
    '/support/ordering/what-is-your-refund-policy' |
    '/support/ordering/what-is-your-refund-policy.html' |
    '/support/referral-program/do-my-referral-rewards-expire' |
    '/support/referral-program/do-my-referral-rewards-expire.html' |
    '/support/referral-program/do-referral-codes-work-on-any-kind-of-order' |
    '/support/referral-program/do-referral-codes-work-on-any-kind-of-order.html' |
    '/support/referral-program/how-do-I-know-when-my-referral-code-is-used' |
    '/support/referral-program/how-do-I-know-when-my-referral-code-is-used.html' |
    '/support/referral-program/how-to-check-rewards-balance' |
    '/support/referral-program/how-to-check-rewards-balance.html' |
    '/support/referral-program/non-transferable-rewards' |
    '/support/referral-program/non-transferable-rewards.html' |
    '/tax-exemptions' |
    '/tax-exemptions.html' |
    '/terms' |
    '/terms.html' |
    '/thread-colors' |
    '/thread-colors.html' |
    '/ticket' |
    '/ticket.html' |
    '/tracking' |
    '/tracking.html' |
    '/translucent-color-challenge-coins' |
    '/translucent-color-challenge-coins.html' |
    '/types' |
    '/types.html' |
    '/types/index' |
    '/types/index.html' |
    '/uploads' |
    '/uploads.html' |
    '/uses' |
    '/uses.html' |
    '/uses/index' |
    '/uses/index.html' |
    '/veteran-challenge-coins' |
    '/veteran-challenge-coins.html' |
    '/wedding-coins' |
    '/wedding-coins.html' |
    '/why-stop-at-just-coins' |
    '/why-stop-at-just-coins.html' |
    '/years-of-service-coins' |
    '/years-of-service-coins.html';

export function IsFile(path: string): path is File {
    return [
        '/',
        '/_index',
        '/_index.html',
        '/about-signature',
        '/about-signature.html',
        '/account-settings',
        '/account-settings.html',
        '/air-force-coins',
        '/air-force-coins.html',
        '/all-pricing',
        '/all-pricing.html',
        '/all-products',
        '/all-products.html',
        '/army-coins',
        '/army-coins.html',
        '/autism-awareness-month',
        '/autism-awareness-month.html',
        '/baseball-trading-pins',
        '/baseball-trading-pins/index',
        '/baseball-trading-pins/index.html',
        '/blog',
        '/blog.html',
        '/blog/nad87zzpgkst',
        '/blog/nad87zzpgkst.html',
        '/cart',
        '/cart.html',
        '/challenge-coin-design',
        '/challenge-coin-design/index',
        '/challenge-coin-design/index.html',
        '/challenge-coin-history',
        '/challenge-coin-history.html',
        '/change-password',
        '/change-password.html',
        '/checkout',
        '/checkout.html',
        '/coast-guard-coins',
        '/coast-guard-coins.html',
        '/coin-stand',
        '/coin-stand.md',
        '/commemorative-coin',
        '/commemorative-coin.html',
        '/components/img-partial',
        '/components/img-partial/index',
        '/components/img-partial/index.md',
        '/contact',
        '/contact.html',
        '/contact/success',
        '/contact/success.html',
        '/corporate-coins',
        '/corporate-coins.html',
        '/create-a-custom-challenge-coin',
        '/create-a-custom-challenge-coin.html',
        '/custom-3D-challenge-coin',
        '/custom-3D-challenge-coin.html',
        '/custom-bottle-opener',
        '/custom-bottle-opener.html',
        '/custom-bottle-openers',
        '/custom-bottle-openers/index',
        '/custom-bottle-openers/index.md',
        '/custom-club-hobby-challenge-coins',
        '/custom-club-hobby-challenge-coins.html',
        '/custom-company-coin',
        '/custom-company-coin.html',
        '/custom-dog-tag',
        '/custom-dog-tag.html',
        '/custom-ems-challenge-coins',
        '/custom-ems-challenge-coins.html',
        '/custom-golf-ball-marker',
        '/custom-golf-ball-marker.html',
        '/custom-handcuff-bottle-openers',
        '/custom-handcuff-bottle-openers/index',
        '/custom-handcuff-bottle-openers/index.md',
        '/custom-k9-police-coins',
        '/custom-k9-police-coins.html',
        '/custom-law-enforcement-challenge-coins',
        '/custom-law-enforcement-challenge-coins.html',
        '/custom-nypd-challenge-coins',
        '/custom-nypd-challenge-coins.html',
        '/custom-photo-ornaments',
        '/custom-photo-ornaments/index',
        '/custom-photo-ornaments/index.md',
        '/custom-school-coins',
        '/custom-school-coins/index',
        '/custom-school-coins/index.html',
        '/custom-shape-coin',
        '/custom-shape-coin.html',
        '/custom-spinner-coin',
        '/custom-spinner-coin.html',
        '/custom-state-police-challenge-coins',
        '/custom-state-police-challenge-coins.html',
        '/custom-trophies',
        '/custom-trophies/index',
        '/custom-trophies/index.md',
        '/custom-us-navy-challenge-coins',
        '/custom-us-navy-challenge-coins.html',
        '/dashboard',
        '/dashboard.html',
        '/display-coin',
        '/display-coin/index',
        '/display-coin/index.md',
        '/dod-coins',
        '/dod-coins.html',
        '/entertainment-challenge-coin',
        '/entertainment-challenge-coin.html',
        '/error',
        '/error.html',
        '/faq',
        '/faq.html',
        '/firefighter-coin',
        '/firefighter-coin.html',
        '/forgot',
        '/forgot.html',
        '/free-quote',
        '/free-quote.html',
        '/gallery',
        '/gallery.html',
        '/government-coin',
        '/government-coin.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index.md',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/_index',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/_index.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/about-signature',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/about-signature.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/account-settings',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/account-settings.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/all-pricing',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/all-pricing.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/all-products',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/all-products.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/blog',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/blog.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/blog/nad87zzpgkst',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/blog/nad87zzpgkst.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/cart',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/cart.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/challenge-coin-history',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/challenge-coin-history.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/change-password',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/change-password.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/checkout',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/checkout.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/coin-stand',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/coin-stand.md',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/components/img-partial',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/components/img-partial/index',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/components/img-partial/index.md',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/contact',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/contact.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/contact/success',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/contact/success.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/create-a-custom-challenge-coin',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/create-a-custom-challenge-coin.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-bottle-openers',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-bottle-openers/index',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-bottle-openers/index.md',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-handcuff-bottle-openers',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-handcuff-bottle-openers/index',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-handcuff-bottle-openers/index.md',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-trophies',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-trophies/index',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-trophies/index.md',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/dashboard',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/dashboard.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/display-coin',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/display-coin/index',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/display-coin/index.md',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/error',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/error.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/faq',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/faq.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/forgot',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/forgot.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/free-quote',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/free-quote.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/gallery',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/gallery.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/iframe-quote-form',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/iframe-quote-form.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/join',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/join.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/login',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/login-email',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/login-email.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/login.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/no-minimum-custom-coins',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/no-minimum-custom-coins/index',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/no-minimum-custom-coins/index.md',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/notification-settings',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/notification-settings.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/order',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/order-submitted',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/order-submitted.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/order.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders/make-order-payment',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders/make-order-payment.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders/track',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders/track.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/password-reset',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/password-reset.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/payment-history',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/payment-history.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/payment-methods',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/payment-methods.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/personalized-police-coin',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/personalized-police-coin.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/pricing',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/pricing.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/privacy',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/privacy.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/products',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/products.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quote',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quote.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quote/received',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quote/received.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quotes',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quotes.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/rally-towels',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/rally-towels.md',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/revision-requests',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/revision-requests.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/revisions',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/revisions.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/september-coin',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/september-coin.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/shipping-options',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/shipping-options.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/staging',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/staging.md',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/stock-products',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/stock-products.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/ordering/once-I-approve-the-proof-how-do-I-place-my-pin-order-into-production',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/ordering/once-I-approve-the-proof-how-do-I-place-my-pin-order-into-production.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/ordering/what-is-your-refund-policy',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/ordering/what-is-your-refund-policy.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/do-my-referral-rewards-expire',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/do-my-referral-rewards-expire.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/do-referral-codes-work-on-any-kind-of-order',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/do-referral-codes-work-on-any-kind-of-order.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/how-do-I-know-when-my-referral-code-is-used',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/how-do-I-know-when-my-referral-code-is-used.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/how-to-check-rewards-balance',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/how-to-check-rewards-balance.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/non-transferable-rewards',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/non-transferable-rewards.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/tax-exemptions',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/tax-exemptions.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/terms',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/terms.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/ticket',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/ticket.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/tracking',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/tracking.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/uploads',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/uploads.html',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/why-stop-at-just-coins',
        '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/why-stop-at-just-coins.html',
        '/iframe-quote-form',
        '/iframe-quote-form.html',
        '/international-coins',
        '/international-coins.html',
        '/join',
        '/join.html',
        '/large-coins',
        '/large-coins.html',
        '/login',
        '/login-email',
        '/login-email.html',
        '/login.html',
        '/made-in-usa-challenge-coins',
        '/made-in-usa-challenge-coins/index',
        '/made-in-usa-challenge-coins/index.html',
        '/marine-corps-coins',
        '/marine-corps-coins.html',
        '/military-challenge-coin',
        '/military-challenge-coin/index',
        '/military-challenge-coin/index.html',
        '/multi-tool',
        '/multi-tool.html',
        '/new-trading-pin',
        '/new-trading-pin.html',
        '/no-minimum-custom-coins',
        '/no-minimum-custom-coins/index',
        '/no-minimum-custom-coins/index.md',
        '/nonprofit-challenge-coins',
        '/nonprofit-challenge-coins.html',
        '/notification-settings',
        '/notification-settings.html',
        '/order',
        '/order-submitted',
        '/order-submitted.html',
        '/order.html',
        '/orders',
        '/orders.html',
        '/orders/make-order-payment',
        '/orders/make-order-payment.html',
        '/orders/track',
        '/orders/track.html',
        '/password-reset',
        '/password-reset.html',
        '/payment-history',
        '/payment-history.html',
        '/payment-methods',
        '/payment-methods.html',
        '/personalized-police-coin',
        '/personalized-police-coin.html',
        '/plating-options',
        '/plating-options.html',
        '/police-coin',
        '/police-coin/index',
        '/police-coin/index.html',
        '/pricing',
        '/pricing.html',
        '/privacy',
        '/privacy.html',
        '/products',
        '/products.html',
        '/quote',
        '/quote.html',
        '/quote/received',
        '/quote/received.html',
        '/quotes',
        '/quotes.html',
        '/rally-towels',
        '/rally-towels.md',
        '/revision-requests',
        '/revision-requests.html',
        '/revisions',
        '/revisions.html',
        '/round-challenge-coin',
        '/round-challenge-coin.html',
        '/safety-coins',
        '/safety-coins.html',
        '/september-coin',
        '/september-coin.html',
        '/shedding-some-light-on-glow-in-the-dark-challenge-coins',
        '/shedding-some-light-on-glow-in-the-dark-challenge-coins.html',
        '/shipping-options',
        '/shipping-options.html',
        '/sports-coin',
        '/sports-coin.html',
        '/staging',
        '/staging.md',
        '/start-a-rush-trading-pin-design',
        '/start-a-rush-trading-pin-design.html',
        '/stock-products',
        '/stock-products.html',
        '/support',
        '/support.html',
        '/support/ordering/once-I-approve-the-proof-how-do-I-place-my-pin-order-into-production',
        '/support/ordering/once-I-approve-the-proof-how-do-I-place-my-pin-order-into-production.html',
        '/support/ordering/what-is-your-refund-policy',
        '/support/ordering/what-is-your-refund-policy.html',
        '/support/referral-program/do-my-referral-rewards-expire',
        '/support/referral-program/do-my-referral-rewards-expire.html',
        '/support/referral-program/do-referral-codes-work-on-any-kind-of-order',
        '/support/referral-program/do-referral-codes-work-on-any-kind-of-order.html',
        '/support/referral-program/how-do-I-know-when-my-referral-code-is-used',
        '/support/referral-program/how-do-I-know-when-my-referral-code-is-used.html',
        '/support/referral-program/how-to-check-rewards-balance',
        '/support/referral-program/how-to-check-rewards-balance.html',
        '/support/referral-program/non-transferable-rewards',
        '/support/referral-program/non-transferable-rewards.html',
        '/tax-exemptions',
        '/tax-exemptions.html',
        '/terms',
        '/terms.html',
        '/thread-colors',
        '/thread-colors.html',
        '/ticket',
        '/ticket.html',
        '/tracking',
        '/tracking.html',
        '/translucent-color-challenge-coins',
        '/translucent-color-challenge-coins.html',
        '/types',
        '/types.html',
        '/types/index',
        '/types/index.html',
        '/uploads',
        '/uploads.html',
        '/uses',
        '/uses.html',
        '/uses/index',
        '/uses/index.html',
        '/veteran-challenge-coins',
        '/veteran-challenge-coins.html',
        '/wedding-coins',
        '/wedding-coins.html',
        '/why-stop-at-just-coins',
        '/why-stop-at-just-coins.html',
        '/years-of-service-coins',
        '/years-of-service-coins.html',
    ].includes(path);
}

export function Relref(path: File): string {
    switch (path) {
    case '/':
        return '/';
    case '/_index':
        return '/';
    case '/_index.html':
        return '/';
    case '/about-signature':
        return '/about-signature/';
    case '/about-signature.html':
        return '/about-signature/';
    case '/account-settings':
        return '/account-settings/';
    case '/account-settings.html':
        return '/account-settings/';
    case '/air-force-coins':
        return 'https://my.signaturecoins.com/air-force-coins/';
    case '/air-force-coins.html':
        return 'https://my.signaturecoins.com/air-force-coins/';
    case '/all-pricing':
        return '/all-pricing/';
    case '/all-pricing.html':
        return '/all-pricing/';
    case '/all-products':
        return '/all-products/';
    case '/all-products.html':
        return '/all-products/';
    case '/army-coins':
        return 'https://my.signaturecoins.com/army-coins/';
    case '/army-coins.html':
        return 'https://my.signaturecoins.com/army-coins/';
    case '/autism-awareness-month':
        return 'https://my.signaturecoins.com/autism-awareness-month/';
    case '/autism-awareness-month.html':
        return 'https://my.signaturecoins.com/autism-awareness-month/';
    case '/baseball-trading-pins':
        return 'https://my.signaturepins.com/baseball-trading-pins/';
    case '/baseball-trading-pins/index':
        return 'https://my.signaturepins.com/baseball-trading-pins/';
    case '/baseball-trading-pins/index.html':
        return 'https://my.signaturepins.com/baseball-trading-pins/';
    case '/blog':
        return '/blog/';
    case '/blog.html':
        return '/blog/';
    case '/blog/nad87zzpgkst':
        return '/blog/look-at-my-cool-new-post/';
    case '/blog/nad87zzpgkst.html':
        return '/blog/look-at-my-cool-new-post/';
    case '/cart':
        return '/cart/';
    case '/cart.html':
        return '/cart/';
    case '/challenge-coin-design':
        return 'https://my.signaturecoins.com/challenge-coin-design-101-how-to-design-your-own-challenge-coins/';
    case '/challenge-coin-design/index':
        return 'https://my.signaturecoins.com/challenge-coin-design-101-how-to-design-your-own-challenge-coins/';
    case '/challenge-coin-design/index.html':
        return 'https://my.signaturecoins.com/challenge-coin-design-101-how-to-design-your-own-challenge-coins/';
    case '/challenge-coin-history':
        return '/challenge-coin-history/';
    case '/challenge-coin-history.html':
        return '/challenge-coin-history/';
    case '/change-password':
        return '/change-password/';
    case '/change-password.html':
        return '/change-password/';
    case '/checkout':
        return '/checkout/';
    case '/checkout.html':
        return '/checkout/';
    case '/coast-guard-coins':
        return 'https://my.signaturecoins.com/coast-guard-coins/';
    case '/coast-guard-coins.html':
        return 'https://my.signaturecoins.com/coast-guard-coins/';
    case '/coin-stand':
        return '/coin-stands/';
    case '/coin-stand.md':
        return '/coin-stands/';
    case '/commemorative-coin':
        return 'https://my.signaturecoins.com/commemorative-coin/';
    case '/commemorative-coin.html':
        return 'https://my.signaturecoins.com/commemorative-coin/';
    case '/components/img-partial':
        return '/components/img-partial/';
    case '/components/img-partial/index':
        return '/components/img-partial/';
    case '/components/img-partial/index.md':
        return '/components/img-partial/';
    case '/contact':
        return '/contact/';
    case '/contact.html':
        return '/contact/';
    case '/contact/success':
        return '/contact/success/';
    case '/contact/success.html':
        return '/contact/success/';
    case '/corporate-coins':
        return 'https://my.signaturecoins.com/corporate-coins/';
    case '/corporate-coins.html':
        return 'https://my.signaturecoins.com/corporate-coins/';
    case '/create-a-custom-challenge-coin':
        return '/create-a-custom-challenge-coin/';
    case '/create-a-custom-challenge-coin.html':
        return '/create-a-custom-challenge-coin/';
    case '/custom-3D-challenge-coin':
        return 'https://my.signaturecoins.com/custom-3d-challenge-coin/';
    case '/custom-3D-challenge-coin.html':
        return 'https://my.signaturecoins.com/custom-3d-challenge-coin/';
    case '/custom-bottle-opener':
        return 'https://my.signaturecoins.com/custom-bottle-opener/';
    case '/custom-bottle-opener.html':
        return 'https://my.signaturecoins.com/custom-bottle-opener/';
    case '/custom-bottle-openers':
        return '/custom-bottle-openers/';
    case '/custom-bottle-openers/index':
        return '/custom-bottle-openers/';
    case '/custom-bottle-openers/index.md':
        return '/custom-bottle-openers/';
    case '/custom-club-hobby-challenge-coins':
        return 'https://my.signaturecoins.com/custom-club-hobby-challenge-coins/';
    case '/custom-club-hobby-challenge-coins.html':
        return 'https://my.signaturecoins.com/custom-club-hobby-challenge-coins/';
    case '/custom-company-coin':
        return 'https://my.signaturecoins.com/custom-company-coin/';
    case '/custom-company-coin.html':
        return 'https://my.signaturecoins.com/custom-company-coin/';
    case '/custom-dog-tag':
        return 'https://my.signaturecoins.com/custom-dog-tag/';
    case '/custom-dog-tag.html':
        return 'https://my.signaturecoins.com/custom-dog-tag/';
    case '/custom-ems-challenge-coins':
        return 'https://my.signaturecoins.com/custom-ems-challenge-coins/';
    case '/custom-ems-challenge-coins.html':
        return 'https://my.signaturecoins.com/custom-ems-challenge-coins/';
    case '/custom-golf-ball-marker':
        return 'https://my.signaturecoins.com/custom-golf-ball-marker/';
    case '/custom-golf-ball-marker.html':
        return 'https://my.signaturecoins.com/custom-golf-ball-marker/';
    case '/custom-handcuff-bottle-openers':
        return '/custom-handcuff-bottle-openers/';
    case '/custom-handcuff-bottle-openers/index':
        return '/custom-handcuff-bottle-openers/';
    case '/custom-handcuff-bottle-openers/index.md':
        return '/custom-handcuff-bottle-openers/';
    case '/custom-k9-police-coins':
        return 'https://my.signaturecoins.com/custom-k9-police-coins/';
    case '/custom-k9-police-coins.html':
        return 'https://my.signaturecoins.com/custom-k9-police-coins/';
    case '/custom-law-enforcement-challenge-coins':
        return 'https://my.signaturecoins.com/custom-law-enforcement-challenge-coins/';
    case '/custom-law-enforcement-challenge-coins.html':
        return 'https://my.signaturecoins.com/custom-law-enforcement-challenge-coins/';
    case '/custom-nypd-challenge-coins':
        return 'https://my.signaturecoins.com/custom-nypd-challenge-coins/';
    case '/custom-nypd-challenge-coins.html':
        return 'https://my.signaturecoins.com/custom-nypd-challenge-coins/';
    case '/custom-photo-ornaments':
        return 'https://my.signaturepins.com/custom-photo-ornaments/';
    case '/custom-photo-ornaments/index':
        return 'https://my.signaturepins.com/custom-photo-ornaments/';
    case '/custom-photo-ornaments/index.md':
        return 'https://my.signaturepins.com/custom-photo-ornaments/';
    case '/custom-school-coins':
        return 'https://my.signaturecoins.com/custom-school-coins/';
    case '/custom-school-coins/index':
        return 'https://my.signaturecoins.com/custom-school-coins/';
    case '/custom-school-coins/index.html':
        return 'https://my.signaturecoins.com/custom-school-coins/';
    case '/custom-shape-coin':
        return 'https://my.signaturecoins.com/custom-shape-coin/';
    case '/custom-shape-coin.html':
        return 'https://my.signaturecoins.com/custom-shape-coin/';
    case '/custom-spinner-coin':
        return 'https://my.signaturecoins.com/custom-spinner-coin/';
    case '/custom-spinner-coin.html':
        return 'https://my.signaturecoins.com/custom-spinner-coin/';
    case '/custom-state-police-challenge-coins':
        return 'https://my.signaturecoins.com/custom-state-police-challenge-coins/';
    case '/custom-state-police-challenge-coins.html':
        return 'https://my.signaturecoins.com/custom-state-police-challenge-coins/';
    case '/custom-trophies':
        return '/custom-trophies/';
    case '/custom-trophies/index':
        return '/custom-trophies/';
    case '/custom-trophies/index.md':
        return '/custom-trophies/';
    case '/custom-us-navy-challenge-coins':
        return 'https://my.signaturecoins.com/custom-us-navy-challenge-coins/';
    case '/custom-us-navy-challenge-coins.html':
        return 'https://my.signaturecoins.com/custom-us-navy-challenge-coins/';
    case '/dashboard':
        return '/dashboard/';
    case '/dashboard.html':
        return '/dashboard/';
    case '/display-coin':
        return '/display-sized-coins/';
    case '/display-coin/index':
        return '/display-sized-coins/';
    case '/display-coin/index.md':
        return '/display-sized-coins/';
    case '/dod-coins':
        return 'https://my.signaturecoins.com/dod-coins/';
    case '/dod-coins.html':
        return 'https://my.signaturecoins.com/dod-coins/';
    case '/entertainment-challenge-coin':
        return 'https://my.signaturecoins.com/entertainment-challenge-coin/';
    case '/entertainment-challenge-coin.html':
        return 'https://my.signaturecoins.com/entertainment-challenge-coin/';
    case '/error':
        return '/error/';
    case '/error.html':
        return '/error/';
    case '/faq':
        return '/faq/';
    case '/faq.html':
        return '/faq/';
    case '/firefighter-coin':
        return 'https://my.signaturecoins.com/firefighter-coin/';
    case '/firefighter-coin.html':
        return 'https://my.signaturecoins.com/firefighter-coin/';
    case '/forgot':
        return '/forgot/';
    case '/forgot.html':
        return '/forgot/';
    case '/free-quote':
        return '/free-quote/';
    case '/free-quote.html':
        return '/free-quote/';
    case '/gallery':
        return '/gallery/';
    case '/gallery.html':
        return '/gallery/';
    case '/government-coin':
        return 'https://my.signaturecoins.com/government-coin/';
    case '/government-coin.html':
        return 'https://my.signaturecoins.com/government-coin/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components':
        return '/components/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index':
        return '/components/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index.md':
        return '/components/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content':
        return 'https://my.signaturecoins.com/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/_index':
        return 'https://my.signaturecoins.com/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/_index.html':
        return 'https://my.signaturecoins.com/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/about-signature':
        return 'https://my.signaturecoins.com/about-signature/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/about-signature.html':
        return 'https://my.signaturecoins.com/about-signature/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/account-settings':
        return 'https://my.signaturecoins.com/account-settings/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/account-settings.html':
        return 'https://my.signaturecoins.com/account-settings/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/all-pricing':
        return 'https://my.signaturecoins.com/all-pricing/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/all-pricing.html':
        return 'https://my.signaturecoins.com/all-pricing/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/all-products':
        return 'https://my.signaturecoins.com/all-products/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/all-products.html':
        return 'https://my.signaturecoins.com/all-products/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/blog':
        return 'https://my.signaturecoins.com/blog/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/blog.html':
        return 'https://my.signaturecoins.com/blog/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/blog/nad87zzpgkst':
        return 'https://my.signaturecoins.com/blog/look-at-my-cool-new-post/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/blog/nad87zzpgkst.html':
        return 'https://my.signaturecoins.com/blog/look-at-my-cool-new-post/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/cart':
        return 'https://my.signaturecoins.com/cart/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/cart.html':
        return 'https://my.signaturecoins.com/cart/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/challenge-coin-history':
        return 'https://my.signaturecoins.com/challenge-coin-history/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/challenge-coin-history.html':
        return 'https://my.signaturecoins.com/challenge-coin-history/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/change-password':
        return 'https://my.signaturecoins.com/change-password/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/change-password.html':
        return 'https://my.signaturecoins.com/change-password/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/checkout':
        return 'https://my.signaturecoins.com/checkout/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/checkout.html':
        return 'https://my.signaturecoins.com/checkout/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/coin-stand':
        return 'https://my.signaturecoins.com/coin-stands/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/coin-stand.md':
        return 'https://my.signaturecoins.com/coin-stands/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/components/img-partial':
        return 'https://my.signaturecoins.com/components/img-partial/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/components/img-partial/index':
        return 'https://my.signaturecoins.com/components/img-partial/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/components/img-partial/index.md':
        return 'https://my.signaturecoins.com/components/img-partial/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/contact':
        return 'https://my.signaturecoins.com/contact/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/contact.html':
        return 'https://my.signaturecoins.com/contact/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/contact/success':
        return 'https://my.signaturecoins.com/contact/success/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/contact/success.html':
        return 'https://my.signaturecoins.com/contact/success/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/create-a-custom-challenge-coin':
        return 'https://my.signaturecoins.com/create-a-custom-challenge-coin/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/create-a-custom-challenge-coin.html':
        return 'https://my.signaturecoins.com/create-a-custom-challenge-coin/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-bottle-openers':
        return 'https://my.signaturecoins.com/custom-bottle-openers/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-bottle-openers/index':
        return 'https://my.signaturecoins.com/custom-bottle-openers/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-bottle-openers/index.md':
        return 'https://my.signaturecoins.com/custom-bottle-openers/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-handcuff-bottle-openers':
        return 'https://my.signaturecoins.com/custom-handcuff-bottle-openers/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-handcuff-bottle-openers/index':
        return 'https://my.signaturecoins.com/custom-handcuff-bottle-openers/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-handcuff-bottle-openers/index.md':
        return 'https://my.signaturecoins.com/custom-handcuff-bottle-openers/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-trophies':
        return 'https://my.signaturecoins.com/custom-trophies/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-trophies/index':
        return 'https://my.signaturecoins.com/custom-trophies/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/custom-trophies/index.md':
        return 'https://my.signaturecoins.com/custom-trophies/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/dashboard':
        return 'https://my.signaturecoins.com/dashboard/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/dashboard.html':
        return 'https://my.signaturecoins.com/dashboard/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/display-coin':
        return 'https://my.signaturecoins.com/display-sized-coins/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/display-coin/index':
        return 'https://my.signaturecoins.com/display-sized-coins/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/display-coin/index.md':
        return 'https://my.signaturecoins.com/display-sized-coins/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/error':
        return 'https://my.signaturecoins.com/error/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/error.html':
        return 'https://my.signaturecoins.com/error/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/faq':
        return 'https://my.signaturecoins.com/faq/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/faq.html':
        return 'https://my.signaturecoins.com/faq/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/forgot':
        return 'https://my.signaturecoins.com/forgot/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/forgot.html':
        return 'https://my.signaturecoins.com/forgot/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/free-quote':
        return 'https://my.signaturecoins.com/free-quote/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/free-quote.html':
        return 'https://my.signaturecoins.com/free-quote/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/gallery':
        return 'https://my.signaturecoins.com/gallery/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/gallery.html':
        return 'https://my.signaturecoins.com/gallery/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/iframe-quote-form':
        return 'https://my.signaturecoins.com/iframe-quote-form/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/iframe-quote-form.html':
        return 'https://my.signaturecoins.com/iframe-quote-form/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/join':
        return 'https://my.signaturecoins.com/join/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/join.html':
        return 'https://my.signaturecoins.com/join/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/login':
        return 'https://my.signaturecoins.com/login/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/login-email':
        return 'https://my.signaturecoins.com/login-email/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/login-email.html':
        return 'https://my.signaturecoins.com/login-email/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/login.html':
        return 'https://my.signaturecoins.com/login/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/no-minimum-custom-coins':
        return 'https://my.signaturecoins.com/no-minimum-custom-coins/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/no-minimum-custom-coins/index':
        return 'https://my.signaturecoins.com/no-minimum-custom-coins/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/no-minimum-custom-coins/index.md':
        return 'https://my.signaturecoins.com/no-minimum-custom-coins/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/notification-settings':
        return 'https://my.signaturecoins.com/notification-settings/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/notification-settings.html':
        return 'https://my.signaturecoins.com/notification-settings/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/order':
        return 'https://my.signaturecoins.com/order/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/order-submitted':
        return 'https://my.signaturecoins.com/order-submitted/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/order-submitted.html':
        return 'https://my.signaturecoins.com/order-submitted/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/order.html':
        return 'https://my.signaturecoins.com/order/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders':
        return 'https://my.signaturecoins.com/orders/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders.html':
        return 'https://my.signaturecoins.com/orders/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders/make-order-payment':
        return 'https://my.signaturecoins.com/orders/make-order-payment/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders/make-order-payment.html':
        return 'https://my.signaturecoins.com/orders/make-order-payment/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders/track':
        return 'https://my.signaturecoins.com/orders/track/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/orders/track.html':
        return 'https://my.signaturecoins.com/orders/track/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/password-reset':
        return 'https://my.signaturecoins.com/password-reset/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/password-reset.html':
        return 'https://my.signaturecoins.com/password-reset/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/payment-history':
        return 'https://my.signaturecoins.com/payment-history/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/payment-history.html':
        return 'https://my.signaturecoins.com/payment-history/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/payment-methods':
        return 'https://my.signaturecoins.com/payment-methods/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/payment-methods.html':
        return 'https://my.signaturecoins.com/payment-methods/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/personalized-police-coin':
        return 'https://my.signaturecoins.com/semi-custom-coins/personalize-a-police-coin/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/personalized-police-coin.html':
        return 'https://my.signaturecoins.com/semi-custom-coins/personalize-a-police-coin/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/pricing':
        return 'https://my.signaturelanyards.com/pricing/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/pricing.html':
        return 'https://my.signaturelanyards.com/pricing/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/privacy':
        return 'https://my.signaturecoins.com/privacy/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/privacy.html':
        return 'https://my.signaturecoins.com/privacy/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/products':
        return 'https://my.signaturecoins.com/products/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/products.html':
        return 'https://my.signaturecoins.com/products/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quote':
        return 'https://my.signaturecoins.com/quote/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quote.html':
        return 'https://my.signaturecoins.com/quote/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quote/received':
        return 'https://my.signaturecoins.com/quote/received/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quote/received.html':
        return 'https://my.signaturecoins.com/quote/received/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quotes':
        return 'https://my.signaturecoins.com/quotes/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/quotes.html':
        return 'https://my.signaturecoins.com/quotes/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/rally-towels':
        return 'https://my.signaturecoins.com/rally-towels/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/rally-towels.md':
        return 'https://my.signaturecoins.com/rally-towels/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/revision-requests':
        return 'https://my.signaturecoins.com/revision-requests/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/revision-requests.html':
        return 'https://my.signaturecoins.com/revision-requests/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/revisions':
        return 'https://my.signaturecoins.com/revisions/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/revisions.html':
        return 'https://my.signaturecoins.com/revisions/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/september-coin':
        return 'https://my.signaturecoins.com/semi-custom-coins/september-11-coin/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/september-coin.html':
        return 'https://my.signaturecoins.com/semi-custom-coins/september-11-coin/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/shipping-options':
        return 'https://my.signaturecoins.com/shipping-options/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/shipping-options.html':
        return 'https://my.signaturecoins.com/shipping-options/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/staging':
        return 'https://my.signaturecoins.com/staging/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/staging.md':
        return 'https://my.signaturecoins.com/staging/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/stock-products':
        return 'https://my.signaturecoins.com/shop/stock-and-personalized-products/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/stock-products.html':
        return 'https://my.signaturecoins.com/shop/stock-and-personalized-products/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support':
        return 'https://my.signaturecoins.com/support/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support.html':
        return 'https://my.signaturecoins.com/support/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/ordering/once-I-approve-the-proof-how-do-I-place-my-pin-order-into-production':
        return 'https://my.signaturecoins.com/support/ordering/once-i-approve-the-proof-how-do-i-place-my-pin-order-into-production/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/ordering/once-I-approve-the-proof-how-do-I-place-my-pin-order-into-production.html':
        return 'https://my.signaturecoins.com/support/ordering/once-i-approve-the-proof-how-do-i-place-my-pin-order-into-production/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/ordering/what-is-your-refund-policy':
        return 'https://my.signaturecoins.com/support/ordering/what-is-your-refund-policy/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/ordering/what-is-your-refund-policy.html':
        return 'https://my.signaturecoins.com/support/ordering/what-is-your-refund-policy/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/do-my-referral-rewards-expire':
        return 'https://my.signaturecoins.com/support/referral-program/do-my-referral-rewards-expire/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/do-my-referral-rewards-expire.html':
        return 'https://my.signaturecoins.com/support/referral-program/do-my-referral-rewards-expire/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/do-referral-codes-work-on-any-kind-of-order':
        return 'https://my.signaturecoins.com/support/referral-program/do-referral-codes-work-on-any-kind-of-order/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/do-referral-codes-work-on-any-kind-of-order.html':
        return 'https://my.signaturecoins.com/support/referral-program/do-referral-codes-work-on-any-kind-of-order/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/how-do-I-know-when-my-referral-code-is-used':
        return 'https://my.signaturecoins.com/support/referral-program/how-do-i-know-when-my-referral-code-is-used/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/how-do-I-know-when-my-referral-code-is-used.html':
        return 'https://my.signaturecoins.com/support/referral-program/how-do-i-know-when-my-referral-code-is-used/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/how-to-check-rewards-balance':
        return 'https://my.signaturecoins.com/support/referral-program/how-to-check-rewards-balance/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/how-to-check-rewards-balance.html':
        return 'https://my.signaturecoins.com/support/referral-program/how-to-check-rewards-balance/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/non-transferable-rewards':
        return 'https://my.signaturecoins.com/support/referral-program/non-transferable-rewards/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/support/referral-program/non-transferable-rewards.html':
        return 'https://my.signaturecoins.com/support/referral-program/non-transferable-rewards/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/tax-exemptions':
        return 'https://my.signaturecoins.com/tax-exemptions/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/tax-exemptions.html':
        return 'https://my.signaturecoins.com/tax-exemptions/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/terms':
        return 'https://my.signaturecoins.com/terms/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/terms.html':
        return 'https://my.signaturecoins.com/terms/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/ticket':
        return 'https://my.signaturecoins.com/ticket/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/ticket.html':
        return 'https://my.signaturecoins.com/ticket/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/tracking':
        return 'https://my.signaturecoins.com/tracking/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/tracking.html':
        return 'https://my.signaturecoins.com/tracking/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/uploads':
        return 'https://my.signaturecoins.com/uploads/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/uploads.html':
        return 'https://my.signaturecoins.com/uploads/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/why-stop-at-just-coins':
        return 'https://my.signaturecoins.com/why-stop-at-just-coins/';
    case '/home/brian/actions-runner-5/_work/StirlingMarketingGroup/StirlingMarketingGroup/signature/content/why-stop-at-just-coins.html':
        return 'https://my.signaturecoins.com/why-stop-at-just-coins/';
    case '/iframe-quote-form':
        return '/iframe-quote-form/';
    case '/iframe-quote-form.html':
        return '/iframe-quote-form/';
    case '/international-coins':
        return 'https://my.signaturecoins.com/international-coins/';
    case '/international-coins.html':
        return 'https://my.signaturecoins.com/international-coins/';
    case '/join':
        return '/join/';
    case '/join.html':
        return '/join/';
    case '/large-coins':
        return 'https://my.signaturecoins.com/large-coins/';
    case '/large-coins.html':
        return 'https://my.signaturecoins.com/large-coins/';
    case '/login':
        return '/login/';
    case '/login-email':
        return '/login-email/';
    case '/login-email.html':
        return '/login-email/';
    case '/login.html':
        return '/login/';
    case '/made-in-usa-challenge-coins':
        return 'https://my.signaturecoins.com/made-in-usa-challenge-coins/';
    case '/made-in-usa-challenge-coins/index':
        return 'https://my.signaturecoins.com/made-in-usa-challenge-coins/';
    case '/made-in-usa-challenge-coins/index.html':
        return 'https://my.signaturecoins.com/made-in-usa-challenge-coins/';
    case '/marine-corps-coins':
        return 'https://my.signaturecoins.com/marine-corps-coins/';
    case '/marine-corps-coins.html':
        return 'https://my.signaturecoins.com/marine-corps-coins/';
    case '/military-challenge-coin':
        return 'https://my.signaturecoins.com/military-challenge-coin/';
    case '/military-challenge-coin/index':
        return 'https://my.signaturecoins.com/military-challenge-coin/';
    case '/military-challenge-coin/index.html':
        return 'https://my.signaturecoins.com/military-challenge-coin/';
    case '/multi-tool':
        return 'https://my.signaturecoins.com/multi-tool/';
    case '/multi-tool.html':
        return 'https://my.signaturecoins.com/multi-tool/';
    case '/new-trading-pin':
        return 'https://my.signaturepins.com/start-a-trading-pin-design/';
    case '/new-trading-pin.html':
        return 'https://my.signaturepins.com/start-a-trading-pin-design/';
    case '/no-minimum-custom-coins':
        return '/no-minimum-custom-coins/';
    case '/no-minimum-custom-coins/index':
        return '/no-minimum-custom-coins/';
    case '/no-minimum-custom-coins/index.md':
        return '/no-minimum-custom-coins/';
    case '/nonprofit-challenge-coins':
        return 'https://my.signaturecoins.com/nonprofit-challenge-coins/';
    case '/nonprofit-challenge-coins.html':
        return 'https://my.signaturecoins.com/nonprofit-challenge-coins/';
    case '/notification-settings':
        return '/notification-settings/';
    case '/notification-settings.html':
        return '/notification-settings/';
    case '/order':
        return '/order/';
    case '/order-submitted':
        return '/order-submitted/';
    case '/order-submitted.html':
        return '/order-submitted/';
    case '/order.html':
        return '/order/';
    case '/orders':
        return '/orders/';
    case '/orders.html':
        return '/orders/';
    case '/orders/make-order-payment':
        return '/orders/make-order-payment/';
    case '/orders/make-order-payment.html':
        return '/orders/make-order-payment/';
    case '/orders/track':
        return '/orders/track/';
    case '/orders/track.html':
        return '/orders/track/';
    case '/password-reset':
        return '/password-reset/';
    case '/password-reset.html':
        return '/password-reset/';
    case '/payment-history':
        return '/payment-history/';
    case '/payment-history.html':
        return '/payment-history/';
    case '/payment-methods':
        return '/payment-methods/';
    case '/payment-methods.html':
        return '/payment-methods/';
    case '/personalized-police-coin':
        return '/semi-custom-coins/personalize-a-police-coin/';
    case '/personalized-police-coin.html':
        return '/semi-custom-coins/personalize-a-police-coin/';
    case '/plating-options':
        return 'https://my.signaturecoins.com/plating-options/';
    case '/plating-options.html':
        return 'https://my.signaturecoins.com/plating-options/';
    case '/police-coin':
        return 'https://my.signaturecoins.com/police-coin/';
    case '/police-coin/index':
        return 'https://my.signaturecoins.com/police-coin/';
    case '/police-coin/index.html':
        return 'https://my.signaturecoins.com/police-coin/';
    case '/pricing':
        return '/pricing/';
    case '/pricing.html':
        return '/pricing/';
    case '/privacy':
        return '/privacy/';
    case '/privacy.html':
        return '/privacy/';
    case '/products':
        return '/products/';
    case '/products.html':
        return '/products/';
    case '/quote':
        return '/quote/';
    case '/quote.html':
        return '/quote/';
    case '/quote/received':
        return '/quote/received/';
    case '/quote/received.html':
        return '/quote/received/';
    case '/quotes':
        return '/quotes/';
    case '/quotes.html':
        return '/quotes/';
    case '/rally-towels':
        return '/rally-towels/';
    case '/rally-towels.md':
        return '/rally-towels/';
    case '/revision-requests':
        return '/revision-requests/';
    case '/revision-requests.html':
        return '/revision-requests/';
    case '/revisions':
        return '/revisions/';
    case '/revisions.html':
        return '/revisions/';
    case '/round-challenge-coin':
        return 'https://my.signaturecoins.com/round-challenge-coin/';
    case '/round-challenge-coin.html':
        return 'https://my.signaturecoins.com/round-challenge-coin/';
    case '/safety-coins':
        return 'https://my.signaturecoins.com/safety-coins/';
    case '/safety-coins.html':
        return 'https://my.signaturecoins.com/safety-coins/';
    case '/september-coin':
        return '/semi-custom-coins/september-11-coin/';
    case '/september-coin.html':
        return '/semi-custom-coins/september-11-coin/';
    case '/shedding-some-light-on-glow-in-the-dark-challenge-coins':
        return 'https://my.signaturecoins.com/shedding-some-light-on-glow-in-the-dark-challenge-coins/';
    case '/shedding-some-light-on-glow-in-the-dark-challenge-coins.html':
        return 'https://my.signaturecoins.com/shedding-some-light-on-glow-in-the-dark-challenge-coins/';
    case '/shipping-options':
        return '/shipping-options/';
    case '/shipping-options.html':
        return '/shipping-options/';
    case '/sports-coin':
        return 'https://my.signaturecoins.com/sports-coin/';
    case '/sports-coin.html':
        return 'https://my.signaturecoins.com/sports-coin/';
    case '/staging':
        return '/staging/';
    case '/staging.md':
        return '/staging/';
    case '/start-a-rush-trading-pin-design':
        return 'https://my.signaturepins.com/start-a-rush-trading-pin-design/';
    case '/start-a-rush-trading-pin-design.html':
        return 'https://my.signaturepins.com/start-a-rush-trading-pin-design/';
    case '/stock-products':
        return '/shop/stock-and-personalized-products/';
    case '/stock-products.html':
        return '/shop/stock-and-personalized-products/';
    case '/support':
        return '/support/';
    case '/support.html':
        return '/support/';
    case '/support/ordering/once-I-approve-the-proof-how-do-I-place-my-pin-order-into-production':
        return '/support/ordering/once-i-approve-the-proof-how-do-i-place-my-pin-order-into-production/';
    case '/support/ordering/once-I-approve-the-proof-how-do-I-place-my-pin-order-into-production.html':
        return '/support/ordering/once-i-approve-the-proof-how-do-i-place-my-pin-order-into-production/';
    case '/support/ordering/what-is-your-refund-policy':
        return '/support/ordering/what-is-your-refund-policy/';
    case '/support/ordering/what-is-your-refund-policy.html':
        return '/support/ordering/what-is-your-refund-policy/';
    case '/support/referral-program/do-my-referral-rewards-expire':
        return '/support/referral-program/do-my-referral-rewards-expire/';
    case '/support/referral-program/do-my-referral-rewards-expire.html':
        return '/support/referral-program/do-my-referral-rewards-expire/';
    case '/support/referral-program/do-referral-codes-work-on-any-kind-of-order':
        return '/support/referral-program/do-referral-codes-work-on-any-kind-of-order/';
    case '/support/referral-program/do-referral-codes-work-on-any-kind-of-order.html':
        return '/support/referral-program/do-referral-codes-work-on-any-kind-of-order/';
    case '/support/referral-program/how-do-I-know-when-my-referral-code-is-used':
        return '/support/referral-program/how-do-i-know-when-my-referral-code-is-used/';
    case '/support/referral-program/how-do-I-know-when-my-referral-code-is-used.html':
        return '/support/referral-program/how-do-i-know-when-my-referral-code-is-used/';
    case '/support/referral-program/how-to-check-rewards-balance':
        return '/support/referral-program/how-to-check-rewards-balance/';
    case '/support/referral-program/how-to-check-rewards-balance.html':
        return '/support/referral-program/how-to-check-rewards-balance/';
    case '/support/referral-program/non-transferable-rewards':
        return '/support/referral-program/non-transferable-rewards/';
    case '/support/referral-program/non-transferable-rewards.html':
        return '/support/referral-program/non-transferable-rewards/';
    case '/tax-exemptions':
        return '/tax-exemptions/';
    case '/tax-exemptions.html':
        return '/tax-exemptions/';
    case '/terms':
        return '/terms/';
    case '/terms.html':
        return '/terms/';
    case '/thread-colors':
        return 'https://my.signaturepatches.com/thread-colors/';
    case '/thread-colors.html':
        return 'https://my.signaturepatches.com/thread-colors/';
    case '/ticket':
        return '/ticket/';
    case '/ticket.html':
        return '/ticket/';
    case '/tracking':
        return '/tracking/';
    case '/tracking.html':
        return '/tracking/';
    case '/translucent-color-challenge-coins':
        return 'https://my.signaturecoins.com/translucent-color-challenge-coins/';
    case '/translucent-color-challenge-coins.html':
        return 'https://my.signaturecoins.com/translucent-color-challenge-coins/';
    case '/types':
        return 'https://my.signaturecoins.com/custom-challenge-coins/';
    case '/types.html':
        return 'https://my.signaturelanyards.com/types/';
    case '/types/index':
        return 'https://my.signaturecoins.com/custom-challenge-coins/';
    case '/types/index.html':
        return 'https://my.signaturecoins.com/custom-challenge-coins/';
    case '/uploads':
        return '/uploads/';
    case '/uploads.html':
        return '/uploads/';
    case '/uses':
        return 'https://my.signaturecoins.com/custom-challenge-coin-uses/';
    case '/uses.html':
        return 'https://my.signaturelanyards.com/uses/';
    case '/uses/index':
        return 'https://my.signaturecoins.com/custom-challenge-coin-uses/';
    case '/uses/index.html':
        return 'https://my.signaturecoins.com/custom-challenge-coin-uses/';
    case '/veteran-challenge-coins':
        return 'https://my.signaturecoins.com/veteran-challenge-coins/';
    case '/veteran-challenge-coins.html':
        return 'https://my.signaturecoins.com/veteran-challenge-coins/';
    case '/wedding-coins':
        return 'https://my.signaturecoins.com/wedding-coins/';
    case '/wedding-coins.html':
        return 'https://my.signaturecoins.com/wedding-coins/';
    case '/why-stop-at-just-coins':
        return '/why-stop-at-just-coins/';
    case '/why-stop-at-just-coins.html':
        return '/why-stop-at-just-coins/';
    case '/years-of-service-coins':
        return 'https://my.signaturecoins.com/years-of-service-coins/';
    case '/years-of-service-coins.html':
        return 'https://my.signaturecoins.com/years-of-service-coins/';
    }
}
